import React from "react";
import { motion } from "framer-motion";
import uoft from "../assets/uoft.png";

const chip =
	"inline-flex items-center rounded-full px-3 py-1 text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700/70 dark:text-gray-200 border border-gray-200 dark:border-gray-600";

export function Education() {
	return (
		<section id="education" className="py-16 ">
			<div className="container mx-auto px-4">
				<h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-10 text-center">
					Education
				</h2>

				<div className="space-y-8">
					{/* Material Engineering Degree */}
					<motion.div
						initial={{ opacity: 0, y: 40 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6 }}
						className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/90 dark:bg-gray-800/70 shadow-lg hover:shadow-xl transition-shadow"
					>
						<div className="p-6 md:p-8">
							<div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8">
								<img
									src={uoft}
									alt="University of Toronto Logo"
									className="w-28 h-28 rounded-full object-cover shadow-md ring-2 ring-gray-200 dark:ring-gray-700"
								/>
								<div className="text-center md:text-left">
									<h3 className="text-xl font-semibold text-gray-900 dark:text-white">
										Master of Applied Science 
									</h3>
									
									<p className="text-gray-600 dark:text-gray-400">
										Faculty of Applied Science & Engineering, University of
										Toronto
									</p>
									<p className="text-sm italic text-gray-500 dark:text-gray-400">
										Sept 2026 - Aug 2028 (Expected)
									</p>

									<div className="h-px bg-gray-200 dark:bg-gray-700 my-4" />

									<h4 className="font-medium text-gray-800 dark:text-gray-200 mb-3">
										Research Focus
									</h4>
									<div className="flex flex-wrap gap-2">
										Machine Learning & Optical Sensor Development
									</div>
								</div>
							</div>
						</div>
					</motion.div>

					{/* Mechanical Engineering Degree */}
					<motion.div
						initial={{ opacity: 0, y: 40 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6 }}
						className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/90 dark:bg-gray-800/70 shadow-lg hover:shadow-xl transition-shadow"
					>
						<div className="p-6 md:p-8">
							<div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8">
								<img
									src={uoft}
									alt="University of Toronto Logo"
									className="w-28 h-28 rounded-full object-cover shadow-md ring-2 ring-gray-200 dark:ring-gray-700"
								/>
								<div className="text-center md:text-left">
									<h3 className="text-xl font-semibold text-gray-900 dark:text-white">
										Bachelor of Applied Science – Mechanical Engineering
									</h3>
									<p className="text-stone-600 dark:text-slate-400 font-medium mt-1">
										Focus in Mechatronics & Robotics
									</p>
									<p className="text-gray-600 dark:text-gray-400">
										Faculty of Applied Science & Engineering, University of
										Toronto
									</p>
									<p className="text-sm italic text-gray-500 dark:text-gray-400">
										Sept 2022 – May 2026
									</p>

									<div className="h-px bg-gray-200 dark:bg-gray-700 my-4" />

									<h4 className="font-medium text-gray-800 dark:text-gray-200 mb-3">
										Relevant Coursework
									</h4>
									<div className="flex flex-wrap gap-2">
										<span className={chip}>Control Systems</span>
										<span className={chip}>Mechanics</span>
										<span className={chip}>Quality Control</span>
										<span className={chip}>Dynamics</span>
										<span className={chip}>Kinematics</span>
										<span className={chip}>Circuit Analysis</span>
										<span className={chip}>Digital Electronics</span>
										<span className={chip}>Analog Electronics</span>
										<span className={chip}>Automatic Manufacturing</span>
										<span className={chip}>Microcontrollers</span>
										<span className={chip}>Fluid Mechanics</span>
										<span className={chip}>Heat & Mass Transfer</span>
										<span className={chip}>Electric Vehicle Design</span>
									</div>
								</div>
							</div>
						</div>
					</motion.div>

					{/* CS Minor */}
					<motion.div
						initial={{ opacity: 0, y: 40 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: 0.1 }}
						className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/90 dark:bg-gray-800/70 shadow-lg hover:shadow-xl transition-shadow"
					>
						<div className="p-6 md:p-8">
							<div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8">
								<img
									src={uoft}
									alt="University of Toronto Logo"
									className="w-28 h-28 rounded-full object-cover shadow-md ring-2 ring-gray-200 dark:ring-gray-700"
								/>
								<div className="text-center md:text-left">
									<h3 className="text-xl font-semibold text-gray-900 dark:text-white">
										Minor in Computer Science
									</h3>
									<p className="text-gray-600 dark:text-gray-400">
										Faculty of Arts & Science, University of Toronto
									</p>
									<p className="text-sm italic text-gray-500 dark:text-gray-400">
										Sept 2022 – Apr 2026
									</p>

									<div className="h-px bg-gray-200 dark:bg-gray-700 my-4" />

									<h4 className="font-medium text-gray-800 dark:text-gray-200 mb-3">
										Relevant Coursework
									</h4>
									<div className="flex flex-wrap gap-2">
										<span className={chip}>Object-Oriented Programming</span>
										<span className={chip}>Data Structures & Algorithms</span>
										<span className={chip}>Computer Organization</span>
										<span className={chip}>Operating Systems</span>
										<span className={chip}>Web Development</span>
										<span className={chip}>Machine Learning</span>
										<span className={chip}>Deep Learning</span>
										<span className={chip}>Databases</span>
									</div>
								</div>
							</div>
						</div>
					</motion.div>
					{/* <motion.div
						initial={{ opacity: 0, y: 40 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6 }}
						className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/90 dark:bg-gray-800/70 shadow-lg hover:shadow-xl transition-shadow"
					>
						<div className="p-6 md:p-8">
							<div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8">
								<img
									src={uoft}
									alt="University of Toronto Logo"
									className="w-28 h-28 rounded-full object-cover shadow-md ring-2 ring-gray-200 dark:ring-gray-700"
								/>
								<div className="text-center md:text-left">
									<h3 className="text-xl font-semibold text-gray-900 dark:text-white">
										Bachelor of Applied Science – Material Science Engineering
									</h3> 
									
									<p className="text-gray-600 dark:text-gray-400">
										Faculty of Applied Science & Engineering, University of
										Toronto
									</p>
									<p className="text-sm italic text-gray-500 dark:text-gray-400">
										Sept 2020 – May 2022
									</p>

									<div className="h-px bg-gray-200 dark:bg-gray-700 my-4" />

									<h4 className="font-medium text-gray-800 dark:text-gray-200 mb-3">
										Relevant Coursework
									</h4>
									<div className="flex flex-wrap gap-2">
										<span className={chip}>Structure & Characterization of Materials</span>
										<span className={chip}>Inorganic Chemistry</span>
										<span className={chip}>Mechanics of Solid Materials</span>
										<span className={chip}>Material Engineering Process</span>
										<span className={chip}>Diffusion & Kinetics</span>
										{/* <span className={chip}>Circuit Analysis</span>
										<span className={chip}>Materials Science</span>
										<span className={chip}>Automatic Manufacturing</span>
										<span className={chip}>Microcontrollers</span>
										<span className={chip}>Fluid Mechanics</span>
										<span className={chip}>Heat & Mass Transfer</span>
										<span className={chip}>Finite Element Analysis</span> 
									</div>
								</div>
							</div>
						</div>
					</motion.div> */}
				</div>
			</div>
		</section>
	);
}
